// extracted by mini-css-extract-plugin
export default {"GeneralModal":"GeneralModal_GeneralModal__bezrg"};